import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  ContainerButton,
  Description,
  Title,
  Button,
  ButtonCancel,
} from './styles';

const SystemCheck = (props) => {
  const {
    setCurrentStep,
    STEPS,
    history,
  } = props;

  const handleCancel = () => {
    history.goBack();
  };

  const handleNextStep = () => {
    setCurrentStep(STEPS.MICROPHONE_CHECK);
  };

  useEffect(() => {
    if (!navigator.userAgent.includes('Mac OS X 10_15')) {
      handleNextStep();
    }
  }, []);

  return (
    <Container>
      <Title>System check</Title>

      <Description>
        It looks like you are using macOS Catalina or newer
        and may need to update your settings in Chrome and System Preferences.
      </Description>

      <ContainerButton>
        <ButtonCancel onClick={handleCancel}>
          Cancel
        </ButtonCancel>
        <Button onClick={handleNextStep}>
          Continue
        </Button>
      </ContainerButton>
    </Container>
  );
};

SystemCheck.propTypes = {
  setCurrentStep: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  STEPS: PropTypes.shape({
    MICROPHONE_CHECK: PropTypes.string,
  }).isRequired,
};

export default SystemCheck;
